/* NeoPlay Theme JS v3 — Cart Drawer, Search, Dark/Light, Mobile Menu */
(function() {
  'use strict';
  var uiController = new AbortController();
  function listen(target, type, handler, options) {
    if (!target) return;
    var config = typeof options === 'boolean' ? { capture: options } : Object.assign({}, options);
    config.signal = uiController.signal;
    target.addEventListener(type, handler, config);
  }


  function applyHeaderThemeState() {
    var header = document.querySelector('.np-header');
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 40);
  }

  /* ---- Dark / Light Mode ---- */
  function initThemeToggle() {
    var storageKey = 'neoplay-theme';
    var legacyKey = 'np-theme';

    function getSystemTheme() {
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) return 'dark';
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) return 'light';
      return 'dark';
    }

    function getSavedTheme() {
      try {
        var saved = localStorage.getItem(storageKey);
        if (saved === 'light' || saved === 'dark') return saved;

        var legacy = localStorage.getItem(legacyKey);
        if (legacy === 'light' || legacy === 'dark') {
          localStorage.setItem(storageKey, legacy);
          return legacy;
        }
      } catch(e) {}
      return null;
    }

    function updateToggleState(theme) {
      var isLight = theme === 'light';
      var label = isLight ? 'Tema chiaro attivo. Passa al tema scuro' : 'Tema scuro attivo. Passa al tema chiaro';
      var btn = document.getElementById('np-theme-toggle');
      var btnMobile = document.getElementById('np-mobile-theme-toggle');

      [btn, btnMobile].forEach(function(toggleButton) {
        if (!toggleButton) return;
        toggleButton.setAttribute('aria-label', label);
        toggleButton.setAttribute('aria-pressed', isLight ? 'true' : 'false');
        toggleButton.setAttribute('data-theme-current', theme);
        if (toggleButton.title !== undefined) toggleButton.title = 'Tema chiaro/scuro';
      });
    }

    function applyTheme(theme, persist) {
      if (theme !== 'light' && theme !== 'dark') theme = 'dark';
      document.documentElement.classList.toggle('light-mode', theme === 'light');
      document.documentElement.setAttribute('data-theme', theme);
      document.dispatchEvent(new CustomEvent('neoplay:themechange', { detail: { theme: theme } }));
      if (persist) {
        try {
          localStorage.setItem(storageKey, theme);
          localStorage.setItem(legacyKey, theme);
        } catch(e) {}
      }
      updateToggleState(theme);
      applyHeaderThemeState();
    }

    var initialTheme = getSavedTheme() || getSystemTheme();
    applyTheme(initialTheme, false);
    applyHeaderThemeState();

    function toggle() {
      document.documentElement.classList.add('np-theme-switching');
      var nextTheme = document.documentElement.classList.contains('light-mode') ? 'dark' : 'light';
      applyTheme(nextTheme, true);
      window.setTimeout(function() {
        document.documentElement.classList.remove('np-theme-switching');
      }, 80);
    }

    var btn = document.getElementById('np-theme-toggle');
    if (btn) listen(btn, 'click', toggle);

    var btnMobile = document.getElementById('np-mobile-theme-toggle');
    if (btnMobile) listen(btnMobile, 'click', toggle);
  }

  /* ---- Search Bar ---- */
  function initSearch() {
    var toggleBtn = document.getElementById('np-search-toggle');
    var closeBtn  = document.getElementById('np-search-close');
    var bar       = document.getElementById('np-search-bar');
    var input     = document.getElementById('np-search-input');
    if (!toggleBtn || !bar) return;

    function openSearch() {
      bar.inert = false;
      toggleBtn.setAttribute('aria-expanded', 'true');
      bar.classList.add('is-open');
      bar.setAttribute('aria-hidden', 'false');
      if (input) setTimeout(function() { input.focus(); }, 100);
    }
    function closeSearch() {
      var restoreFocus = bar.contains(document.activeElement);
      bar.inert = true;
      toggleBtn.setAttribute('aria-expanded', 'false');
      bar.classList.remove('is-open');
      if (restoreFocus) toggleBtn.focus({ preventScroll: true });
      bar.setAttribute('aria-hidden', 'true');
    }

    listen(toggleBtn, 'click', function() {
      bar.classList.contains('is-open') ? closeSearch() : openSearch();
    });
    if (closeBtn) listen(closeBtn, 'click', closeSearch);

    listen(document, 'keydown', function(e) {
      if (e.key === 'Escape') closeSearch();
    });
  }

  /* ---- Cart Drawer ---- */
  var cartDrawer, cartOverlay, cartBody, cartCount;

  function cartText(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.inert = false;
    cartDrawer.setAttribute('aria-hidden', 'false');
    var trigger = document.getElementById('np-cart-toggle');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    cartDrawer.classList.add('is-open');
    if (window.NeoPlayDialogs) NeoPlayDialogs.open(cartDrawer, trigger, closeCartDrawer);
    if (cartOverlay) cartOverlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    renderCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer || !cartDrawer.classList.contains('is-open')) return;
    if (window.NeoPlayDialogs) NeoPlayDialogs.close();
    cartDrawer.inert = true;
    cartDrawer.setAttribute('aria-hidden', 'true');
    var trigger = document.getElementById('np-cart-toggle');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  var cartRenderSequence = 0;
  function renderCartDrawer() {
    if (!cartBody) return;
    var renderId = ++cartRenderSequence;
    cartBody.innerHTML = '<div class="np-cart-drawer__loading"><div class="np-spinner"></div></div>';

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (renderId !== cartRenderSequence) return;
        updateCartCountBadge(cart.item_count);
        updateDrawerTitle(cart.item_count);

        if (cart.item_count === 0) {
          cartBody.innerHTML = '<div class="np-cart-drawer__empty">' +
            '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
            '<p>Il tuo carrello \u00e8 vuoto</p>' +
            '<a href="/collections/all">Inizia a fare shopping</a>' +
            '</div>';
          updateFooter(0);
          return;
        }

        var html = '';
        cart.items.forEach(function(item) {
          var imgSrc = item.image ? item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=160' : '';
          html += '<div class="np-cart-drawer__item" data-key="' + cartText(item.key) + '">' +
            (imgSrc ? '<img class="np-cart-drawer__item-img" src="' + cartText(imgSrc) + '" alt="' + cartText(item.title) + '" loading="lazy">' : '<div class="np-cart-drawer__item-img"></div>') +
            '<div class="np-cart-drawer__item-info">' +
              '<div class="np-cart-drawer__item-title">' + cartText(item.product_title) + '</div>' +
              (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="np-cart-drawer__item-variant">' + cartText(item.variant_title) + '</div>' : '') +
              '<div class="np-cart-drawer__item-bottom">' +
                '<span class="np-cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
                '<div class="np-cart-drawer__item-qty">' +
                  '<button class="np-drawer-qty-minus" data-key="' + cartText(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Diminuisci">&#8722;</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button class="np-drawer-qty-plus" data-key="' + cartText(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Aumenta">&#43;</button>' +
                '</div>' +
                '<button class="np-cart-drawer__item-remove" data-key="' + cartText(item.key) + '">Rimuovi</button>' +
              '</div>' +
            '</div>' +
            '</div>';
        });
        cartBody.innerHTML = html;
        updateFooter(cart.total_price);
        bindDrawerItemEvents();
      })
      .catch(function() {
        if (renderId !== cartRenderSequence) return;
        cartBody.innerHTML = '<div class="np-cart-drawer__empty"><p>Errore nel caricamento del carrello.</p></div>';
      });
  }

  function updateDrawerTitle(count) {
    var titleCount = document.querySelector('.np-cart-drawer__title-count');
    if (titleCount) titleCount.textContent = count + (count === 1 ? ' articolo' : ' articoli');
  }

  function updateFooter(totalCents) {
    var foot = document.querySelector('.np-cart-drawer__foot');
    if (!foot) return;
    if (totalCents === 0) {
      foot.style.display = 'none';
      return;
    }
    foot.style.display = '';
    var priceEl = foot.querySelector('.np-cart-drawer__subtotal-price');
    if (priceEl) priceEl.textContent = formatMoney(totalCents);
  }

  function updateCartCountBadge(count) {
    var badges = document.querySelectorAll('.np-cart-count');
    badges.forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  var cartMutationPending = false;
  function changeCartQty(key, qty) {
    if (cartMutationPending || !Number.isFinite(qty) || qty < 0) return;
    cartMutationPending = true;
    cartBody.setAttribute('aria-busy', 'true');
    cartBody.querySelectorAll('button').forEach(function (button) { button.disabled = true; });
    cartBody.querySelectorAll('.np-cart-error').forEach(function (error) { error.remove(); });
    fetch((window.routes && routes.cart_change_url) || '/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.errors || data.status >= 400) throw new Error(data.description || data.message || 'Quantità non disponibile.');
        return data;
      });
    }).then(function (cart) {
      updateCartCountBadge(cart.item_count);
      renderCartDrawer();
    }).catch(function (error) {
      var message = document.createElement('p'); message.className = 'np-cart-error';
      message.setAttribute('role', 'alert'); message.textContent = error.message || 'Impossibile aggiornare il carrello. Riprova.';
      cartBody.prepend(message);
    }).finally(function () {
      cartMutationPending = false;
      cartBody.removeAttribute('aria-busy');
      cartBody.querySelectorAll('button').forEach(function (button) { button.disabled = false; });
    });
  }

  function bindDrawerItemEvents() {
    if (!cartBody) return;
    cartBody.querySelectorAll('.np-drawer-qty-minus, .np-drawer-qty-plus').forEach(function(btn) {
      listen(btn, 'click', function() {
        changeCartQty(btn.dataset.key, parseInt(btn.dataset.qty, 10));
      });
    });
    cartBody.querySelectorAll('.np-cart-drawer__item-remove').forEach(function(btn) {
      listen(btn, 'click', function() {
        changeCartQty(btn.dataset.key, 0);
      });
    });
  }

  function initCartDrawer() {
    cartDrawer  = document.getElementById('np-cart-drawer');
    cartOverlay = document.getElementById('np-cart-overlay');
    cartBody    = document.getElementById('np-cart-drawer-body');

    var openBtn  = document.getElementById('np-cart-toggle');
    var closeBtn = document.getElementById('np-cart-drawer-close');

    if (cartBody) bindDrawerItemEvents();
    if (openBtn)  listen(openBtn, 'click', openCartDrawer);
    if (closeBtn) listen(closeBtn, 'click', closeCartDrawer);
    if (cartOverlay) listen(cartOverlay, 'click', closeCartDrawer);

    listen(document, 'keydown', function(e) {
      if (e.key === 'Escape') closeCartDrawer();
    });

    function showCartToast(message) {
      var toast = document.querySelector('.np-cart-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'np-cart-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        document.body.appendChild(toast);
      }
      toast.innerHTML = '<span class="np-cart-toast__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.6"></circle><circle cx="18" cy="20" r="1.6"></circle><path d="M3 4h2l2.2 10.4a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 2-1.5L21 8H7"></path></svg></span><span>' + escapeToastText(message || 'Aggiunto al carrello') + '</span>';
      toast.classList.add('is-visible');
      window.clearTimeout(toast._npTimer);
      toast._npTimer = window.setTimeout(function() {
        toast.classList.remove('is-visible');
      }, 2000);
    }

    function escapeToastText(value) {
      return String(value || '').replace(/[&<>"']/g, function(char) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
      });
    }

    listen(document, 'neoplay:cart:added', function(event) {
      var button = event.detail && event.detail.button;
      if (button) {
        button.classList.add('np-added');
        window.setTimeout(function() {
          button.classList.remove('np-added');
        }, 1400);
      }
      showCartToast('Aggiunto al carrello');
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(response) { return response.json(); })
        .then(function(cart) { updateCartCountBadge(cart.item_count); })
        .catch(function() {});
    });
  }

  /* ---- Add to Cart AJAX (product page) ---- */
  function initAddToCart() {
    var form = document.getElementById('np-product-form');
    if (!form) return;
    listen(form, 'submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.np-add-to-cart');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Aggiunto!'; btn.disabled = true; }

      var formData = new FormData(form);
      var data = {};
      formData.forEach(function(v, k) { data[k] = v; });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        openCartDrawer();
        if (btn) setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 2000);
      })
      .catch(function() {
        if (btn) { btn.textContent = 'Errore'; setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 2000); }
      });
    });
  }

  /* ---- Quantity Controls (Product Page) ---- */
  function initQtyControls() {
    var minus = document.getElementById('np-qty-minus');
    var plus  = document.getElementById('np-qty-plus');
    var input = document.getElementById('np-qty');
    if (!minus || !plus || !input) return;
    listen(minus, 'click', function() { var v = parseInt(input.value, 10); if (v > 1) input.value = v - 1; });
    listen(plus, 'click',  function() { var v = parseInt(input.value, 10); input.value = v + 1; });
  }

  /* ---- Product Gallery ---- */
  function initGallery() {
    var thumbs  = document.querySelectorAll('.np-product-gallery__thumb');
    var mainImg = document.getElementById('np-main-img');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(function(thumb) {
      listen(thumb, 'click', function() {
        mainImg.src = thumb.dataset.src;
        thumbs.forEach(function(t) { t.classList.remove('np-product-gallery__thumb--active'); });
        thumb.classList.add('np-product-gallery__thumb--active');
      });
    });
  }

  /* ---- Cart Page (full page) ---- */
  function initCartPage() {
    var cartItems = document.querySelectorAll('.np-cart-item');
    if (!cartItems.length) return;
    function updateCart(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function() { window.location.reload(); }).catch(function() {});
    }
    document.querySelectorAll('.np-cart-qty-minus').forEach(function(btn) {
      listen(btn, 'click', function() {
        var key = btn.dataset.key;
        var input = document.querySelector('.np-cart-qty-input[data-key="' + key + '"]');
        updateCart(key, Math.max(0, parseInt(input.value, 10) - 1));
      });
    });
    document.querySelectorAll('.np-cart-qty-plus').forEach(function(btn) {
      listen(btn, 'click', function() {
        var key = btn.dataset.key;
        var input = document.querySelector('.np-cart-qty-input[data-key="' + key + '"]');
        updateCart(key, parseInt(input.value, 10) + 1);
      });
    });
    document.querySelectorAll('.np-cart-item__remove').forEach(function(btn) {
      listen(btn, 'click', function() { updateCart(btn.dataset.key, 0); });
    });
  }

  /* ---- Header Scroll Effect ---- */
  function initHeaderScroll() {
    var header = document.querySelector('.np-header');
    if (!header) return;
    listen(window, 'scroll', applyHeaderThemeState, { passive: true });
    applyHeaderThemeState();
  }

  /* ---- Update Cart Count on Load ---- */
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCartCountBadge(cart.item_count); })
      .catch(function() {});
  }



  /* ---- BU Product Carousels ---- */
  function initBUCarousels() {
    var carousels = document.querySelectorAll('[data-np-carousel]');
    if (!carousels.length) return;

    carousels.forEach(function(carousel) {
      var track = carousel.querySelector('[data-np-carousel-track]');
      var prev = carousel.querySelector('[data-np-carousel-prev]');
      var next = carousel.querySelector('[data-np-carousel-next]');
      if (!track || !prev || !next) return;

      function step() {
        var card = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      }

      function updateArrows() {
        var image = track.querySelector('.card__inner');
        if (image) carousel.style.setProperty('--np-carousel-arrow-top', (image.getBoundingClientRect().top - carousel.getBoundingClientRect().top + image.getBoundingClientRect().height / 2) + 'px');
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.classList.toggle('is-disabled', track.scrollLeft <= 2);
        next.classList.toggle('is-disabled', track.scrollLeft >= max);
        if (max <= 2) {
          prev.classList.add('is-disabled');
          next.classList.add('is-disabled');
        }
      }

      listen(prev, 'click', function() {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      listen(next, 'click', function() {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      listen(track, 'scroll', updateArrows, { passive: true });
      listen(window, 'resize', updateArrows);
      setTimeout(updateArrows, 200);
    });
  }


  /* ---- Idempotent lifecycle for storefront and Theme Editor ---- */
  function initUI() {
    uiController.abort(); uiController = new AbortController();
    initThemeToggle(); initSearch(); initCartDrawer();
    initAddToCart(); initQtyControls(); initGallery(); initCartPage(); initBUCarousels(); initHeaderScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initUI(); updateCartCount(); });
  else { initUI(); updateCartCount(); }
  document.addEventListener('shopify:section:load', initUI);
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.querySelector('.np-header')) { closeCartDrawer(); uiController.abort(); }
  });
})();

/* NeoPlay — native menu with keyboard and Editor lifecycle support. */
(function () {
  function init() {
    var details = document.getElementById('np-v9-mobile-menu');
    if (!details || details.dataset.npV9Bound) return;
    details.dataset.npV9Bound = 'true';
    var panel = details.querySelector('.np-v9-mobile-panel');
    var summary = details.querySelector('summary');
    var controller = new AbortController();
    function listen(node, type, handler) { node.addEventListener(type, handler, { signal: controller.signal }); }
    function close() { details.open = false; sync(); }
    function sync() {
      document.documentElement.classList.toggle('np-v9-menu-open', details.open);
      document.body.classList.toggle('np-v9-menu-open', details.open);
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      if (details.open && window.NeoPlayDialogs) NeoPlayDialogs.open(panel, summary, close);
      else if (window.NeoPlayDialogs) NeoPlayDialogs.release(details);
    }
    listen(details, 'toggle', sync);
    details.querySelectorAll('[data-np-v9-close], .np-v9-mobile-link').forEach(function (node) {
      listen(node, 'click', function (event) { if (node.hasAttribute('data-np-v9-close')) event.preventDefault(); close(); });
    });
    listen(document, 'keydown', function (event) { if (event.key === 'Escape' && details.open) close(); });
    listen(window, 'resize', function () { if (innerWidth > 1024 && details.open) close(); });
    details._npCleanup = function () { close(); controller.abort(); };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) { var details = event.target.querySelector('#np-v9-mobile-menu'); if (details && details._npCleanup) details._npCleanup(); });
})();

/* NeoPlay — reopen cookie preferences from footer */
(function() {
  var unavailableWarningShown = false;

  function warnCookiePreferencesUnavailable() {
    if (unavailableWarningShown || typeof console === 'undefined' || typeof console.warn !== 'function') return;
    unavailableWarningShown = true;
    var status = document.getElementById('np-cookie-status');
    if (!status) { status = document.createElement('p'); status.id = 'np-cookie-status'; status.className = 'np-cookie-status'; status.setAttribute('role', 'status'); var footer = document.querySelector('.np-footer'); if (footer) footer.appendChild(status); }
    if (status) status.textContent = 'Preferenze cookie momentaneamente non disponibili. Riprova tra poco.';
    console.warn('Cookie preferences panel is not available on this storefront.');
  }

  function openCookiePreferences() {
    function tryCall(fn, context) {
      if (typeof fn !== 'function') return false;
      try {
        var result = fn.call(context || window);
        if (result && typeof result.catch === 'function') result.catch(function () { warnCookiePreferencesUnavailable(); });
        return true;
      } catch(e) {
        return false;
      }
    }

    function clickNativePreferenceButton(root) {
      if (!root) return false;
      var controls = [];
      try {
        controls = Array.prototype.slice.call(root.querySelectorAll('button, a, [role="button"]'));
      } catch(e) {
        controls = [];
      }

      var clicked = controls.some(function(el) {
        if (!el || el.hasAttribute('data-open-cookie-preferences')) return false;
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        var label = (el.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim().toLowerCase();
        var haystack = text + ' ' + label;
        var isPreferenceControl =
          haystack.indexOf('gestisci le preferenze') !== -1 ||
          haystack.indexOf('gestisci preferenze') !== -1 ||
          haystack.indexOf('preferenze per cookie') !== -1 ||
          haystack.indexOf('preferenze cookie') !== -1 ||
          haystack.indexOf('cookie preferences') !== -1 ||
          haystack.indexOf('manage preferences') !== -1;

        if (!isPreferenceControl) return false;
        try {
          el.click();
          return true;
        } catch(e) {
          return false;
        }
      });

      if (clicked) return true;

      try {
        return Array.prototype.slice.call(root.querySelectorAll('*')).some(function(el) {
          return el.shadowRoot ? clickNativePreferenceButton(el.shadowRoot) : false;
        });
      } catch(e) {
        return false;
      }
    }

    function triggerShopifyReshowHash() {
      var hash = 'shopifyReshowConsentBanner';
      try {
        if (window.location.hash === '#' + hash && window.history && window.history.replaceState) {
          window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
        }

        var anchor = document.createElement('a');
        anchor.href = '#' + hash;
        anchor.setAttribute('aria-hidden', 'true');
        anchor.tabIndex = -1;
        anchor.style.position = 'absolute';
        anchor.style.left = '-9999px';
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        window.setTimeout(function () { if (!document.querySelector('[id^="shopify-pc"]') && !(window.privacyBanner && window.privacyBanner.showPreferences)) warnCookiePreferencesUnavailable(); }, 1200);
        return true;
      } catch(e) {
        return false;
      }
    }

    if (tryCall(window.privacyBanner && window.privacyBanner.showPreferences, window.privacyBanner)) return true;
    if (tryCall(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.showPreferences, window.Shopify.customerPrivacy)) return true;
    if (clickNativePreferenceButton(document)) return true;

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function() {
          if (tryCall(window.privacyBanner && window.privacyBanner.showPreferences, window.privacyBanner)) return;
          if (tryCall(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.showPreferences, window.Shopify.customerPrivacy)) return;
          if (clickNativePreferenceButton(document)) return;
          if (triggerShopifyReshowHash()) return;
          warnCookiePreferencesUnavailable();
        });
        return true;
      } catch(e) {}
    }

    if (triggerShopifyReshowHash()) return true;
    warnCookiePreferencesUnavailable();
    return false;
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target && event.target.closest ? event.target.closest('[data-open-cookie-preferences]') : null;
    if (!trigger) return;
    event.preventDefault();
    openCookiePreferences();
  });
})();

/* NeoPlay — predictive header search + in-shop query filtering */
(function() {
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function normalizeTagHandle(value) {
    var normalized = String(value || '').trim().toLowerCase();
    if (normalized.normalize) {
      normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return normalized
      .replace(/&/g, ' and ')
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function normalizeSearchText(value) {
    var raw = String(value || '').toLowerCase();
    if (raw.normalize) raw = raw.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    raw = raw.replace(/&/g, ' and ').replace(/['’]/g, '');
    var spaced = raw
      .replace(/[-_/]+/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    var dashed = spaced.replace(/\s+/g, '-');
    var compact = spaced.replace(/\s+/g, '');
    return [spaced, dashed, compact].join(' ').trim();
  }

  function getSearchTokens(query) {
    var raw = String(query || '').toLowerCase();
    if (raw.normalize) raw = raw.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return raw
      .replace(/&/g, ' and ')
      .replace(/['’]/g, '')
      .replace(/[-_/]+/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function getPrimarySearchHandle(query) {
    var text = normalizeSearchText(query);
    var tokens = getSearchTokens(query);
    if (!tokens.length) return '';
    if (text.indexOf('one piece') !== -1) return 'one-piece';
    if (text.indexOf('yu gi oh') !== -1 || text.indexOf('yugioh') !== -1) return 'yu-gi-oh';
    if (text.indexOf('dragon ball') !== -1) return 'dragon-ball';
    if (text.indexOf('elite trainer box') !== -1) return 'elite-trainer-box';
    return normalizeTagHandle(tokens[0]);
  }

  function buildShopTagUrl(baseUrl, query) {
    var base = (baseUrl || '/collections/all').split('?')[0].replace(/\/+$/, '');
    var handle = normalizeTagHandle(query);
    return handle ? base + '/' + encodeURIComponent(handle) : base;
  }

  function buildShopSearchUrl(baseUrl, query) {
    var url = new URL((window.routes && routes.search_url) || '/search', location.origin);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('q', String(query || '').trim());
    return url.pathname + url.search;
  }

  function currentFilterParams() {
    var params = new URLSearchParams();
    new URLSearchParams(location.search).forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 || key === 'sort_by') params.append(key, value);
    });
    return params;
  }

  function getUrlSearchQuery() {
    try {
      return new URLSearchParams(window.location.search).get('q') || '';
    } catch (error) {
      return '';
    }
  }

  function getCurrentCollectionSortValue() {
    var sortSelect = document.querySelector('select[name="sort_by"]');
    if (sortSelect && sortSelect.value) return sortSelect.value;
    try {
      return new URLSearchParams(window.location.search).get('sort_by') || '';
    } catch (error) {
      return '';
    }
  }

  function initPredictiveSearch() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('[data-np-predictive-search]'));
    forms.forEach(function(form) {
      if (!form || form.dataset.npPredictiveBound === 'true') return;
      form.dataset.npPredictiveBound = 'true';
      var bindingController = new AbortController();
      function listen(target, event, handler) { target.addEventListener(event, handler, { signal: bindingController.signal }); }

      var input = form.querySelector('input[name="q"]');
      var panel = form.querySelector('[data-np-search-suggestions]');
      var controller = null;
      var timer = null;
      if (!input || !panel) return;
      form._npSearchCleanup = function () { clearTimeout(timer); if (controller) controller.abort(); bindingController.abort(); };

      function hidePanel() {
        panel.hidden = true;
        panel.innerHTML = '';
      }

      function renderProducts(products, query) {
        if (!query) {
          hidePanel();
          return;
        }

        if (!products.length) {
          panel.innerHTML = '<span class="np-search-suggestion__empty">Nessun prodotto trovato</span>';
          panel.hidden = false;
          return;
        }

        panel.innerHTML = products.slice(0, 5).map(function(product) {
          var image = product.image || product.featured_image || '';
          if (image && typeof image === 'object') image = image.url || image.src || '';
          var imageHtml = image
            ? '<img class="np-search-suggestion__image" src="' + escapeHtml(image) + '" alt="">'
            : '<span class="np-search-suggestion__image"></span>';
          var price = product.price || product.price_min || '';
          return '<a class="np-search-suggestion" href="' + escapeHtml(product.url) + '">' +
            imageHtml +
            '<span><span class="np-search-suggestion__title">' + escapeHtml(product.title) + '</span>' +
            (price ? '<span class="np-search-suggestion__price">' + escapeHtml(price) + '</span>' : '') +
            '</span></a>';
        }).join('');
        panel.hidden = false;
      }

      listen(input, 'input', function() {
        var query = input.value.trim();
        window.clearTimeout(timer);
        if (controller) controller.abort();
        if (query.length < 2) {
          hidePanel();
          return;
        }

        timer = window.setTimeout(function() {
          controller = new AbortController();
          fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5', {
            headers: { 'Accept': 'application/json' },
            signal: controller.signal
          })
            .then(function(response) { return response.json(); })
            .then(function(data) {
              var products = (((data || {}).resources || {}).results || {}).products || [];
              renderProducts(products, query);
            })
            .catch(function(error) {
              if (error.name !== 'AbortError') hidePanel();
            });
        }, 160);
      });

      listen(form, 'submit', function(event) {
        var query = input.value.trim();
        if (!query) return;
        event.preventDefault();
        window.location.href = buildShopSearchUrl(form.getAttribute('action'), query);
      });

      listen(document, 'click', function(event) {
        if (!form.contains(event.target)) hidePanel();
      });
      listen(document, 'keydown', function(event) {
        if (event.key === 'Escape') hidePanel();
      });
    });
  }

  function applyCollectionSearchInput(input) {
    if (!input) return;
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var query = input.value.trim();
    if (!grid.dataset.npOriginalHtml) grid.dataset.npOriginalHtml = grid.innerHTML;
    storeOriginalCountText();

    if (!query) {
      if (collectionSearchController) collectionSearchController.abort();
      collectionSearchRequestId += 1;
      updateCollectionSearchUrl(input.form, query);
      restoreCollectionGrid(grid);
      return;
    }

    fetchCollectionTagResults(query, grid, input.form);
  }

  function initCollectionSearch() {
    var inputs = Array.prototype.slice.call(document.querySelectorAll('[data-np-shop-search-input]'));
    inputs.forEach(function(input) {
      if (!input || input.dataset.npShopSearchBound === 'true') return;
      input.dataset.npShopSearchBound = 'true';

      var urlQuery = getUrlSearchQuery();
      if (urlQuery && !input.value.trim()) input.value = urlQuery;

      var timer = null;
      if (input.form) input.form._npSearchCleanup = function () { clearTimeout(timer); };

      function runSearch() {
        var grid = document.getElementById('product-grid');
        if (!grid) return;
        applyCollectionSearchInput(input);
      }

      input.addEventListener('input', function() {
        window.clearTimeout(timer);
        timer = window.setTimeout(runSearch, 240);
      });

      if (input.form) {
        input.form.addEventListener('submit', function(event) {
          event.preventDefault();
          window.clearTimeout(timer);
          runSearch();
        });
      }

      if (input.value.trim()) {
        runSearch();
      }
    });

    document.querySelectorAll('.np-bu-filter__pills .np-bu-pill').forEach(function(link) {
      if (!link || link.dataset.npPreserveSearchBound === 'true') return;
      link.dataset.npPreserveSearchBound = 'true';
      link.addEventListener('click', function(event) {
        var input = document.querySelector('[data-np-shop-search-input]');
        if (!input) return;
        var query = input.value.trim() || getUrlSearchQuery();
        var href = link.getAttribute('href') || '';
        if (!href || href.charAt(0) === '#') return;

        var parts = href.split('?');
        var nextUrl = parts[0].replace(/\/+$/, '');
        var params = currentFilterParams();
        var sortValue = getCurrentCollectionSortValue();
        if (query) params.set('q', query);
        if (sortValue) params.set('sort_by', sortValue);
        var queryString = params.toString();
        if (queryString) nextUrl += '?' + queryString;
        event.preventDefault();
        window.location.href = nextUrl;
      });
    });
  }

  var collectionSearchController = null;
  var collectionSearchRequestId = 0;

  function fetchCollectionTagResults(query, grid, form) {
    if (collectionSearchController) collectionSearchController.abort();
    collectionSearchController = new AbortController();
    var requestId = ++collectionSearchRequestId;
    grid.classList.add('np-search-loading');
    updateCollectionSearchUrl(form, query);

    var url = buildCollectionTagSectionUrl(query, form, grid, 1);
    fetch(url, {
      headers: { 'Accept': 'text/html' },
      signal: collectionSearchController.signal
    })
      .then(function(response) {
        if (requestId !== collectionSearchRequestId) throw new DOMException('Stale search request', 'AbortError');
        if (!response.ok) throw new Error('Search request failed');
        return response.text();
      })
      .then(function(html) {
        if (requestId !== collectionSearchRequestId) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        renderCollectionTagPages([parsed], grid, query, form, requestId);
      })
      .catch(function(error) {
        if (error.name === 'AbortError' || requestId !== collectionSearchRequestId) return;
        applyLocalFallbackSearch(grid, query, form);
        showSearchError(grid, buildShopSearchUrl(null, query));
        /* Keep the existing grid hidden until the fallback AND filter ends. */
        grid.classList.remove('np-search-loading');
      });
  }

  function buildCollectionTagSectionUrl(query, form, grid, page) {
    var base = (form && (form.dataset.npShopBaseUrl || form.getAttribute('action'))) || '/collections/all';
    var url = buildShopTagUrl(base, getPrimarySearchHandle(query));
    var params = currentFilterParams();
    params.set('section_id', (grid && grid.dataset.id) || 'product-grid');
    var sortValue = getCurrentCollectionSortValue();
    if (sortValue) params.set('sort_by', sortValue);
    if (page && page > 1) params.set('page', page);
    url += (url.indexOf('?') === -1 ? '?' : '&') + params.toString();
    return url;
  }

  function renderCollectionTagPages(pages, grid, query, form, requestId) {
    if (requestId && requestId !== collectionSearchRequestId) return;
    var tagNode = pages[0].querySelector('[data-np-result-tags]');
    var appliedTags = [];
    try { appliedTags = (JSON.parse(tagNode && tagNode.textContent) || []).map(normalizeTagHandle); } catch (error) {}
    var primary = getPrimarySearchHandle(query);
    var exactTagQuery = normalizeTagHandle(query) === primary;
    // A removed/unknown tag or additional search terms cannot use the tag total.
    if (!exactTagQuery || appliedTags.indexOf(primary) === -1) {
      fetchSearchFallbackResults(query, grid, form, requestId);
      return;
    }
    var resultItems = pages.map(function(parsed) {
      var resultList = parsed.querySelector('ul#product-grid') ||
        parsed.querySelector('#product-grid ul.product-grid') ||
        parsed.querySelector('ul.product-grid');
      return resultList ? resultList.innerHTML.trim() : '';
    }).filter(Boolean).join('');

    grid.innerHTML = resultItems;
    // This response is already filtered by Shopify within the chosen collection.
    applyLocalFallbackSearch(grid, '', null);
    updateCollectionSearchCounts(pages[0]);
    mountSearchPagination(pages[0], grid, query, form, 'collection');
    grid.classList.remove('np-search-loading');
  }

  function mountSearchPagination(parsed, grid, query, form, mode) {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    container.querySelectorAll('.np-search-pagination').forEach(function (node) { node.remove(); });
    container.querySelectorAll('.pagination-wrapper').forEach(function (node) { node.hidden = true; });
    var pagination = parsed.querySelector('.pagination-wrapper');
    if (!pagination) return;
    var copy = pagination.cloneNode(true);
    copy.classList.add('np-search-pagination');
    copy.hidden = false;
    var paginationBase = new URL(mode === 'collection' ? buildCollectionTagSectionUrl(query, form, grid, 1) : buildShopSearchUrl(null, query), location.origin);
    copy.querySelectorAll('a[href]').forEach(function (link) {
      var url = new URL(link.getAttribute('href'), paginationBase);
      url.searchParams.delete('section_id');
      var preserved = currentFilterParams();
      Array.from(new Set(preserved.keys())).forEach(function (key) {
        if (!url.searchParams.has(key)) preserved.getAll(key).forEach(function (value) { url.searchParams.append(key, value); });
      });
      if (mode === 'collection') url.searchParams.set('q', query);
      link.href = url.pathname + url.search;
      link.addEventListener('click', function (event) {
        event.preventDefault();
        if (collectionSearchController) collectionSearchController.abort();
        collectionSearchController = new AbortController();
        var id = ++collectionSearchRequestId;
        var target = new URL(link.href);
        target.searchParams.set('section_id', mode === 'search' ? 'main-search' : grid.dataset.id);
        grid.classList.add('np-search-loading');
        fetch(target, { signal: collectionSearchController.signal })
          .then(function (response) { if (!response.ok) throw new Error('Page failed'); return response.text(); })
          .then(function (html) {
            if (id !== collectionSearchRequestId) return;
            var next = new DOMParser().parseFromString(html, 'text/html');
            if (mode === 'search') renderSearchFallbackPage(next, grid, query, form);
            else renderCollectionTagPages([next], grid, query, form, id);
            grid.focus({ preventScroll: true });
          })
          .catch(function (error) {
            if (error.name !== 'AbortError' && id === collectionSearchRequestId) showSearchError(grid, link.href);
          })
          .finally(function () { if (id === collectionSearchRequestId) grid.classList.remove('np-search-loading'); });
      });
    });
    container.appendChild(copy);
  }

  function showSearchError(grid, href) {
    setCollectionCountText('Risultati non aggiornati');
    grid.classList.remove('np-search-loading');
    var error = document.createElement('li');
    error.className = 'grid__item np-collection-search-empty';
    error.setAttribute('role', 'status');
    error.textContent = 'Impossibile aggiornare i risultati. ';
    var link = document.createElement('a');
    link.href = href; link.textContent = 'Apri i risultati';
    error.appendChild(link); grid.appendChild(error);
  }

  function renderSearchFallbackPage(parsed, grid, query, form) {
    var list = parsed.querySelector('#product-grid ul.product-grid') || parsed.querySelector('ul#product-grid');
    grid.innerHTML = list ? list.innerHTML : '';
    var scoped = !!(form && form.dataset.npShopCollection);
    applyLocalFallbackSearch(grid, '', scoped ? form : null);
    // Full-text search is global; do not label its total as a collection total
    // when membership still has to be checked locally.
    if (scoped) setCollectionCountText('Risultati nella categoria');
    else updateCollectionSearchCounts(parsed);
    mountSearchPagination(parsed, grid, query, form, 'search');
    grid.classList.remove('np-search-loading');
  }

  function fetchSearchFallbackResults(query, grid, form, requestId) {
    var fallback = new URL((window.routes && routes.search_url) || '/search', location.origin);
    fallback.search = currentFilterParams().toString();
    fallback.searchParams.set('type', 'product');
    fallback.searchParams.set('options[prefix]', 'last');
    fallback.searchParams.set('q', query);
    fallback.searchParams.set('section_id', 'main-search');
    var url = fallback.toString();
    fetch(url, { headers: { 'Accept': 'text/html' }, signal: collectionSearchController.signal })
      .then(function(response) { return response.ok ? response.text() : ''; })
      .then(function(html) {
        if (requestId && requestId !== collectionSearchRequestId) return;
        if (!html) throw new Error('Empty search fallback');
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        renderSearchFallbackPage(parsed, grid, query, form);
      })
      .catch(function(error) {
        if (error.name === 'AbortError' || (requestId && requestId !== collectionSearchRequestId)) return;
        applyLocalFallbackSearch(grid, query, form);
        showSearchError(grid, buildShopSearchUrl(null, query));
        grid.classList.remove('np-search-loading');
      });
  }

  function restoreCollectionGrid(grid) {
    if (grid.dataset.npOriginalHtml) grid.innerHTML = grid.dataset.npOriginalHtml;
    document.querySelectorAll('.np-search-pagination').forEach(function (node) { node.remove(); });
    grid.classList.remove('np-search-loading');
    restoreOriginalCountText();
    toggleCollectionPagination(false);
  }

  function getActiveAreaAliases(form) {
    var area = form && form.dataset ? (form.dataset.npShopActiveArea || 'all') : 'all';
    var aliases = {
      cards: ['cards', 'card', 'carte', 'carta', 'tcg', 'pokemon', 'one-piece', 'one piece', 'yu-gi-oh', 'yu gi oh', 'yugioh', 'magic', 'gundam', 'dragon-ball', 'dragon ball', 'sealed', 'single-card', 'single card', 'singole', 'graded', 'gradate'],
      games: ['games', 'game', 'videogiochi', 'videogioco', 'playstation', 'xbox', 'nintendo', 'switch', 'pc'],
      retro: ['retro', 'retrogames', 'retrogaming', 'vintage', 'ps1', 'ps2', 'ps3', 'nes', 'snes', 'n64', 'gameboy', 'playstation-retro', 'nintendo-retro']
    };
    return aliases[area] || [];
  }

  function applyLocalFallbackSearch(grid, query, form) {
    Array.prototype.slice.call(grid.querySelectorAll('.np-collection-search-empty')).forEach(function(emptyItem) {
      emptyItem.remove();
    });

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-np-product-card]'));
    if (!cards.length) {
      cards = Array.prototype.slice.call(grid.children).filter(function(child) {
        return child.matches && child.matches('.grid__item');
      });
    }
    var tokens = getSearchTokens(query);
    var collectionHandle = form && form.dataset.npShopCollection;
    var areaAliases = getActiveAreaAliases(form).map(normalizeSearchText).filter(Boolean);
    var visible = 0;
    cards.forEach(function(card) {
      var haystack = normalizeSearchText((card.getAttribute('data-np-product-search') || '') + ' ' + (card.textContent || ''));
      var match = !tokens.length || tokens.every(function(token) {
        return haystack.indexOf(token) !== -1;
      });
      if (match && collectionHandle && card.hasAttribute('data-np-product-collections')) {
        match = (card.getAttribute('data-np-product-collections') || '').split(' ').indexOf(collectionHandle) !== -1;
      } else if (match && areaAliases.length) {
        match = areaAliases.some(function(alias) {
          return haystack.indexOf(alias) !== -1;
        });
      }
      card.hidden = !match;
      card.classList.toggle('np-search-hidden', !match);
      card.style.display = match ? '' : 'none';
      if (match) visible += 1;
    });
    if (!visible) {
      grid.insertAdjacentHTML('beforeend', '<li class="grid__item np-collection-search-empty">Nessun prodotto corrisponde alla ricerca in questa pagina. Usa le pagine successive o modifica la ricerca.</li>');
    }
    return visible;
  }

  function reapplyCollectionSearchAfterGridRender() {
    var input = document.querySelector('[data-np-shop-search-input]');
    if (!input) return;

    var query = input.value.trim() || getUrlSearchQuery();
    if (!query) return;
    if (!input.value.trim()) input.value = query;

    /* Facet rendering can replace the grid node. Hide whichever instance is
       currently mounted before applying the existing query again. */
    function hideCurrentGrid() {
      var currentGrid = document.getElementById('product-grid');
      if (currentGrid) currentGrid.classList.add('np-search-loading');
    }

    hideCurrentGrid();
    applyCollectionSearchInput(input);
  }

  function storeOriginalCountText() {
    getCollectionCountNodes().forEach(function(node) {
      if (!node.dataset.npOriginalCountText) node.dataset.npOriginalCountText = node.textContent;
    });
  }

  function restoreOriginalCountText() {
    delete document.documentElement.dataset.npFilteredProductCount;
    getCollectionCountNodes().forEach(function(node) {
      if (node.dataset.npOriginalCountText) node.textContent = node.dataset.npOriginalCountText;
    });
  }

  function setCollectionCountText(text) {
    document.documentElement.dataset.npFilteredProductCount = text;
    getCollectionCountNodes().forEach(function(node) {
      node.textContent = text;
    });
  }

  function updateCollectionSearchCounts(parsed) {
    var metadata = parsed.querySelector('[data-np-result-total]');
    var value = metadata && metadata.getAttribute('data-np-result-total');
    var total = value !== null && value !== '' ? Number(value) : NaN;
    // Use Shopify's complete result count, never the number of mounted cards.
    setCollectionCountText(Number.isFinite(total) && total >= 0 ? total + (total === 1 ? ' risultato' : ' risultati') : 'Risultati');
  }

  function getCollectionCountNodes() {
    return Array.prototype.slice.call(document.querySelectorAll('#ProductCountDesktop, #ProductCount'));
  }

  function toggleCollectionPagination(hidden) {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    Array.prototype.slice.call(container.querySelectorAll('.pagination-wrapper')).forEach(function(pagination) {
      pagination.hidden = !!hidden;
    });
  }

  function updateCollectionSearchUrl(form, query) {
    if (!window.history || !window.history.replaceState || !form) return;
    var base = form.dataset.npShopBaseUrl || form.getAttribute('action') || window.location.pathname;
    var nextUrl = base.split('?')[0].replace(/\/+$/, '');
    var params = currentFilterParams();
    var sortValue = getCurrentCollectionSortValue();
    if (query) params.set('q', query);
    if (sortValue) params.set('sort_by', sortValue);
    var queryString = params.toString();
    if (queryString) nextUrl += '?' + queryString;
    window.history.replaceState({}, '', nextUrl);
  }

  function initNeoPlaySearch() {
    initPredictiveSearch();
    initCollectionSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNeoPlaySearch);
  } else {
    initNeoPlaySearch();
  }
  window.addEventListener('load', initNeoPlaySearch);
  window.addEventListener('pageshow', initNeoPlaySearch);
  document.addEventListener('shopify:section:load', initNeoPlaySearch);
  document.addEventListener('shopify:section:select', initNeoPlaySearch);
  document.addEventListener('neoplay:collection-grid-rendered', reapplyCollectionSearchAfterGridRender);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('form').forEach(function (form) { if (form._npSearchCleanup) form._npSearchCleanup(); });
    if (event.target.querySelector('[data-np-shop-search-input]') && collectionSearchController) collectionSearchController.abort();
  });
})();

/* NeoPlay v9 — catalog tag dropdown/search */
(function() {
  function initTagDropdowns() {
    document.querySelectorAll('[data-np-tag-dropdown]').forEach(function(select) {
      if (select.dataset.npV9Bound === 'true') return;
      select.dataset.npV9Bound = 'true';
      select.addEventListener('change', function() {
        if (this.value) window.location.href = this.value;
      });
    });

    document.querySelectorAll('[data-np-tag-search]').forEach(function(details) {
      if (details.dataset.npTagSearchBound === 'true') return;
      details.dataset.npTagSearchBound = 'true';
      var lifecycle = new AbortController();
      details._npTagCleanup = function () { lifecycle.abort(); };
      function listen(target, type, handler) { target.addEventListener(type, handler, { signal: lifecycle.signal }); }

      var input = details.querySelector('[data-np-tag-input]');
      var items = Array.prototype.slice.call(details.querySelectorAll('[data-np-tag-item]'));

      listen(details, 'toggle', function() {
        if (details.open && input) {
          setTimeout(function() {
            input.focus();
            input.select();
          }, 30);
        }
      });

      if (input) {
        listen(input, 'input', function() {
          var query = input.value.trim().toLowerCase();
          items.forEach(function(item) {
            var label = item.textContent.trim().toLowerCase();
            item.classList.toggle('is-hidden', query && label.indexOf(query) === -1);
          });
        });
      }

      items.forEach(function(item) {
        listen(item, 'click', function() {
          details.open = false;
        });
      });

      listen(document, 'click', function(event) {
        if (details.open && !details.contains(event.target)) details.open = false;
      });

      listen(document, 'keydown', function(event) {
        if (event.key === 'Escape' && details.open) details.open = false;
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTagDropdowns);
  } else {
    initTagDropdowns();
  }
  document.addEventListener('shopify:section:load', initTagDropdowns);
  document.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll('[data-np-tag-search]').forEach(function (node) { if (node._npTagCleanup) node._npTagCleanup(); }); });
})();

/* The homepage featured carousel keeps native touch/trackpad scrolling. */
(function () {
  function initFeatured(root) {
    root.querySelectorAll('[data-np-featured]').forEach(function (section) {
      if (section.dataset.carouselReady) return;
      section.dataset.carouselReady = 'true';
      var track = section.querySelector('[data-np-featured-track]');
      var controls = section.querySelector('.np-featured__controls');
      var prev = section.querySelector('[data-np-featured-prev]');
      var next = section.querySelector('[data-np-featured-next]');
      if (!track || !controls || !prev || !next) return;
      var controller = new AbortController();
      var observer;
      function update() {
        var image = track.querySelector('.card__inner');
        var carousel = section.querySelector('.np-featured__carousel');
        if (image && carousel) carousel.style.setProperty('--np-carousel-arrow-top', (image.getBoundingClientRect().top - carousel.getBoundingClientRect().top + image.getBoundingClientRect().height / 2) + 'px');
        var max = track.scrollWidth - track.clientWidth;
        controls.hidden = max <= 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      }
      function move(direction) {
        var card = track.querySelector('.np-featured__item');
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', function () { move(-1); }, { signal: controller.signal });
      next.addEventListener('click', function () { move(1); }, { signal: controller.signal });
      track.addEventListener('scroll', update, { passive: true, signal: controller.signal });
      if (window.ResizeObserver) { observer = new ResizeObserver(update); observer.observe(track); }
      else window.addEventListener('resize', update, { signal: controller.signal });
      section._npCarouselCleanup = function () { controller.abort(); if (observer) observer.disconnect(); };
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initFeatured(document); });
  else initFeatured(document);
  document.addEventListener('shopify:section:load', function (event) { initFeatured(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll('[data-np-featured]').forEach(function (section) { if (section._npCarouselCleanup) section._npCarouselCleanup(); }); });
})();

/* Load only the hero image for the mode being displayed. */
(function () {
  function sync() {
    var mode = document.documentElement.classList.contains('light-mode') ? 'light' : 'dark';
    document.querySelectorAll('.np-hero').forEach(function (hero) {
      if (hero.querySelector('.np-hero__bg-media--' + mode)) return;
      var template = hero.querySelector('[data-np-hero-template="' + mode + '"]');
      if (!template) return;
      var picture = template.content.firstElementChild.cloneNode(true);
      var img = picture.querySelector('img');
      if (img) img.setAttribute('fetchpriority', 'low');
      template.before(picture);
    });
  }
  document.addEventListener('neoplay:themechange', sync);
  document.addEventListener('shopify:section:load', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
